'use es6';

import { createContext } from 'react';
const FileManagerContext = /*#__PURE__*/createContext({});
export default FileManagerContext;